import React, { useEffect, useState } from 'react';
import { Table, Spin, message } from 'antd';
import axios from '../../../config/axiosInstance';

const InvoicesTab = ({ participantId, host }) => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchInvoices = async () => {
        try {
            const tokenRes = await axios.get(`/regasus/token?host=${host}`);
            const token = tokenRes.data.access_token;

            if (!token) {
                message.error('No token received');
                return;
            }

            const res = await axios.post('/regasus/get-invoices-of-participant', {
                token,
                host,
                recipientID: participantId
            });

            const invoicesRaw = res.data?.invoices;

            // Aseguramos que siempre sea un array
            const parsed = Array.isArray(invoicesRaw)
                ? invoicesRaw
                : invoicesRaw
                    ? [invoicesRaw]
                    : [];

            setInvoices(parsed);
        } catch (err) {
            console.error(err);
            message.error('Failed to load invoices');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvoices();
    }, [participantId, host]);

    const columns = [
        {
            title: 'Invoice Number',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
        },
        {
            title: 'Net',
            key: 'amountNet',
            render: (_, record) => {
                const value = record?.amountNet;
                const currency = record?.currency;
                return value != null ? `${value.toFixed(2)} ${currency}` : '—';
            }
        },
        {
            title: 'Tax',
            key: 'amountTax',
            render: (_, record) => {
                const value = record?.amountTax;
                const currency = record?.currency;
                return value != null ? `${value.toFixed(2)} ${currency}` : '—';
            }
        },
        {
            title: 'Gross',
            key: 'amountGross',
            render: (_, record) => {
                const value = record?.amountGross;
                const currency = record?.currency;
                return value != null ? `${value.toFixed(2)} ${currency}` : '—';
            }
        }
    ];

    return loading ? (
        <Spin />
    ) : (
        <Table
            size="small"
            scroll={{ x: 'max-content' }}
            dataSource={invoices.map((inv, i) => ({ key: inv.id || i, ...inv }))}
            columns={columns}
            pagination={{ pageSize: 10 }}
        />
    );
};

export default InvoicesTab;